<template>
   <!-- 开票申请 -->
   <div class="issue-record">
    <ab-list-query>
        <template #right>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-input placeholder="型号" v-model.trim="formSearch.model" clearable></el-input>
                </el-col>
                <el-col :span="4">
                    <el-input  placeholder="品牌" v-model.trim="formSearch.brand" clearable></el-input>
                </el-col>
                <el-col :span="4">
                    <ab-select
                        url="/p/user/list"
                        placeholder="操作人"
                        inputKey="realName"
                        descKey="realName"
                        v-model="formSearch.createByName"
                        :urlData="{isEnabled: 1 , pageSize: 10, pageNum: 1}"
                        @handleSelect="itemItemUnitName">
                    </ab-select>
                </el-col>
                <el-col :span="4">
                    <ab-timeSearch
                        class="searchBox"
                        startSrc="发布时间起"
                        endSrc="发布时间止"
                        v-model="formSearch.updateTimeArr1"
                        @searchEvent="changeTimeRange"
                    ></ab-timeSearch>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="formSearch.status" placeholder="发布状态" clearable>
                        <el-option value="01" label="已发布"></el-option>
                        <el-option value="02" label="已撤销"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4" class="text-left">
                    <el-button @click="searchForm">搜索</el-button>
                    <el-button link class="btn-svg" @click="formSearch={}"><ab-svg name="qingchu"></ab-svg>清除</el-button>
                </el-col>
            </el-row>
        </template>

        <template #toolbar>
            <el-button @click="exportFile" :loading="load.exportLoading">导出</el-button>
        </template>

        <template #table>
            <ab-table
                class="materialTable"
                ref="table"
                stripe
                showEdit
                showSelection
                selectionWidth="45"
                indexWidth="50"
                widths="120"
                isFilter="operator"
                :column-list="columns"
                :table-list="tableData"
                :dataListLoading="load.isloading"
                @filterColumns="filterColumns"
            >
                <template #operator='scope'>
                    <el-button class="redBtn" :loading="load.cancelLoading" @click="cancelRow(scope.row.id)" :disabled="scope.row.status != '01'">撤销发布</el-button>                
                </template>
            </ab-table>
            
        </template>

        <template #page>
            <ab-page
                :pageTotal="page.total" 
                :currentPage='page.currentPage' 
                :pageSize="page.pageSize" 
                :pageSizes="page.pageSizes"
                @searchForm="pageSearch"
            ></ab-page>
        </template>
    </ab-list-query>
   </div>
</template>

<script>
export default {
    name: 'issue-record',
    data() {
        return {
            load:{
                exportLoading: false,
                cancelLoading: false
            },
            formSearch:{
                status: '01'
            },
            columns: [
                {
                    props: 'createTime',
                    labels: '发布时间',
                    widths: 120,
                },
                {
                    props: 'statusDesc',
                    labels: '状态',
                    widths: 80,
                },
                {
                    props: 'model',
                    labels: '型号',
                    widths: 120,
                },
                {
                    props: 'brand',
                    labels: '品牌',
                    widths: 80
                },
                {
                    props: 'qty',
                    labels: '数量',
                    widths: 80 
                },
                {
                    props: 'spec',
                    labels: '封装',
                    widths: 80
                },
                {
                    props: 'batch',
                    labels: '批次',
                    widths: 80
                },
                {
                    props: 'custOrderNo',
                    labels: '订单编号',
                    widths: 120,
                },
                {
                    props: 'portDate',
                    labels: '进口日期',
                    widths: 120,
                },
                {
                    props: 'createByName',
                    labels: '操作人',
                    widths: 70,
                }
            ],
            tableData: [],
            page: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0
            }
        }
    },
    methods:{
        //联系人
        itemItemUnitName(val){
            this.formSearch.createById = val.id
        },
        //日期
        changeTimeRange(obj){
            this.formSearch.updateTimeArr1=obj
            if (obj) {
                this.formSearch.createTimeStart = obj[0];
                this.formSearch.createTimeEnd = obj[1];
            } else {
                this.formSearch.createTimeStart = "";
                this.formSearch.createTimeEnd = "";
            }
        },
        filterColumns(val){
            this.columns=val
        },
        pageSearch(val){
            this.page.pageSize=val.pageSize
            this.page.currentPage=val.currentPage
            this.getListData()
        },
        //获取数据
        getListData(){
            this.load.isloading=true
            let dataList = {
                data: this.formSearch,
                pageNum: this.page.currentPage, 
                pageSize: this.page.pageSize
            }
            this.$post("/cms/taoicPublished/list",dataList).then(({ data }) => {
                if (data && data.code === "C0000") {
                    this.tableData = data.result .list;
                    this.page.total = data.result.total;
                } else {
                    this.tableData = [];
                    this.page.total = 0;
                }
            }).finally(() => {
                this.load.isloading=false
            });
        },
        //搜索
        searchForm(){
            this.getListData()
        },
        cancelRow(id) {
            this.$confirm('撤销发布将从淘IC取消发布，请确认是否继续？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.load.cancelLoading = true
                this.$post('/cms/taoicPublished/revoke', {id}).then(({data}) => {
                    if(data && data.code === 'C0000') {
                        this.$message.success(data.message)
                    }
                }).finally(() => {
                    this.load.cancelLoading = false
                    this.getListData()
                })
            })
        },
        //列表选择项
        handleSelectionChange(array) {
            this.multipleSelection = array;
        },
        //导出
        exportFile() {
            this.load.exportLoading=true
            let params = {}
            let excelField = this.columns.map(e => e.props);
            params.excelField= excelField 
            params.data = this.formSearch,
            this.$post("/cms/taoicPublished/export", params).then(({ data }) => {
                if (data && data.code === "C0000") {
                    // 创建隐藏的可下载链接
                    var eleLink = document.createElement("a");
                    eleLink.download = "";
                    eleLink.target = "_blank";
                    eleLink.style.display = "none";
                    // 字符内容转变成blob地址
                    eleLink.href = data.message;
                    // 触发点击
                    document.body.appendChild(eleLink);
                    eleLink.click();
                    // 然后移除
                    document.body.removeChild(eleLink);
                } else {
                    this.$message({type: 'error', message: data.message, offset: 380, grouping: true})
                }
            }).finally(() => {
                this.load.exportLoading=false
            });
        },
    },
    created(){
        this.getListData()
    },
    mounted(){this.screenHeight = window.screen.height}
}
</script>

<style lang="scss">
.issue-record{
    .tips {
        background-color: #facd91;
        text-align: center;
        font-size: 12px;
        height: 20px;
        line-height: 20px;
        color: #3b3a39;
        span{
            float: right;
            margin-right: 20px;
            cursor: pointer;
            font-size: 16px;
            margin-top: -2px;
            &:hover{
                opacity: .7;
            }
        }
    }
    .el-menu.el-menu--horizontal{
        display: none;
    }
    .required-class::before{
        content: '*';
        height: 4px;
        width: 4px;
        position: absolute;
        color: red;
    }
}
</style>